import { ReactNode } from 'react';

import ImageWithFallback from '@/components/ImageWithFallback';
import useViewport from '@/hooks/useViewport';

export type BlurredBackgroundProps = {
  imageUrl: string;
  height: number;
  children?: ReactNode;
  gradientPercent?: [number, number];
};

const MobileBlurredBackground = (props: BlurredBackgroundProps) => {
  const { imageUrl, children, height, gradientPercent = [61.6, 100] } = props;
  const [from, to] = gradientPercent;

  return (
    <div className={`relative top-0 w-full overflow-hidden`}>
      <div className="relative w-full" style={{ height }}>
        <ImageWithFallback
          layout={`fill`}
          src={imageUrl}
          alt="blurred-image"
          placeholder="blur"
          blurDataURL={imageUrl}
          objectFit={`cover`}
          key={imageUrl}
        />
      </div>
      <div
        className={`absolute top-0 h-full w-full`}
        style={{
          background: `linear-gradient(180deg, rgba(0, 0, 0, 0) ${from}%, #000000 ${to}%)`,
        }}
      ></div>
      {children}
    </div>
  );
};

const DesktopBlurredBackground = (props: BlurredBackgroundProps) => {
  const { imageUrl, children, height, gradientPercent = [0, 100] } = props;
  const [from, to] = gradientPercent;

  return (
    <div className={`relative top-0 w-full overflow-hidden`}>
      <div className="relative w-full" style={{ height }}>
        <ImageWithFallback
          key={imageUrl}
          placeholder="blur"
          blurDataURL={imageUrl}
          layout={`fill`}
          src={imageUrl}
          alt="blurred-image"
          className={`object-cover blur-[20px]`}
        />
      </div>
      <div
        className={`absolute top-0 h-full w-full`}
        style={{
          background: `linear-gradient(0deg, #000000 ${from}%, rgba(0, 0, 0, 0) ${to}%)`,
        }}
      ></div>
      {children}
    </div>
  );
};

const BlurredBackground = (props: BlurredBackgroundProps) => {
  const {} = props;
  const viewport = useViewport();

  if (viewport == `mobile` || viewport == `tablet`) {
    return <MobileBlurredBackground {...props} />;
  }
  if (viewport == `desktop`) {
    return <DesktopBlurredBackground {...props} />;
  }

  return null;
};

export default BlurredBackground;
